module.exports = __webpack_public_path__ + "img/symbol_5.bfa64531.png";